/* import __COLOCATED_TEMPLATE__ from './truncated-filter-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();